import { useState } from "react";
import { useTranslation } from "react-i18next";
import Seo from "../../components/Seo/Seo";
import "./About.css";

export default function About() {
  const { t } = useTranslation("common");
  const [activeValue, setActiveValue] = useState(0);

  const values = [
    { name: t("about.values.items.0.name"), icon: "authenticity", description: t("about.values.items.0.description") },
    { name: t("about.values.items.1.name"), icon: "sustainability", description: t("about.values.items.1.description") },
    { name: t("about.values.items.2.name"), icon: "partnership", description: t("about.values.items.2.description") },
    { name: t("about.values.items.3.name"), icon: "innovation", description: t("about.values.items.3.description") },
    { name: t("about.values.items.4.name"), icon: "integrity", description: t("about.values.items.4.description") }
  ];

  const services = [
    {
      title: t("about.services.items.0.title"),
      description: t("about.services.items.0.description"),
      icon: "trips"
    },
    {
      title: t("about.services.items.1.title"),
      description: t("about.services.items.1.description"),
      icon: "development"
    },
    {
      title: t("about.services.items.2.title"),
      description: t("about.services.items.2.description"),
      icon: "media"
    },
    {
      title: t("about.services.items.3.title"),
      description: t("about.services.items.3.description"),
      icon: "events"
    },
    {
      title: t("about.services.items.4.title"),
      description: t("about.services.items.4.description"),
      icon: "hospitality"
    },
    {
      title: t("about.services.items.5.title"),
      description: t("about.services.items.5.description"),
      icon: "training"
    }
  ];

  const getValueIcon = (type) => {
    const icons = {
      authenticity: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      sustainability: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2a10 10 0 0110 10 4 4 0 01-5 3.88V20H7v-4.12A4 4 0 012 12 10 10 0 0112 2z"/>
          <path d="M12 2v20"/>
        </svg>
      ),
      partnership: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
        </svg>
      ),
      innovation: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v20M2 12h20"/>
          <circle cx="12" cy="12" r="9"/>
          <path d="M12 6l3 3-3 3"/>
        </svg>
      ),
      integrity: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      )
    };
    return icons[type];
  };

  const getServiceIcon = (type) => {
    const icons = {
      trips: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
      ),
      development: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
        </svg>
      ),
      media: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
          <circle cx="12" cy="13" r="4"/>
        </svg>
      ),
      events: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
          <line x1="16" y1="2" x2="16" y2="6"/>
          <line x1="8" y1="2" x2="8" y2="6"/>
          <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
      ),
      hospitality: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      training: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/>
          <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
        </svg>
      )
    };
    return icons[type];
  };

  return (
    <section className="page aboutPage">
      <Seo
        title={t("about.seo.title")}
        description={t("about.seo.description")}
        path="/about"
      />

      {/* Hero Section */}
      <div className="aboutHero">
        <div className="container">
          <div className="heroContent">
            <h1 className="heroTitle">{t("about.hero.title")}</h1>
            <p className="heroDescription">
              {t("about.hero.description")}
            </p>
            <div className="heroBadges">
              <div className="badge">
                <div className="badgeIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                    <line x1="16" y1="2" x2="16" y2="6"/>
                    <line x1="8" y1="2" x2="8" y2="6"/>
                    <line x1="3" y1="10" x2="21" y2="10"/>
                  </svg>
                </div>
                <div>
                  <div className="badgeLabel">{t("about.hero.badges.founded.label")}</div>
                  <div className="badgeValue">{t("about.hero.badges.founded.value")}</div>
                </div>
              </div>
              <div className="badge">
                <div className="badgeIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div>
                  <div className="badgeLabel">{t("about.hero.badges.location.label")}</div>
                  <div className="badgeValue">{t("about.hero.badges.location.value")}</div>
                </div>
              </div>
              <div className="badge">
                <div className="badgeIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
                  </svg>
                </div>
                <div>
                  <div className="badgeLabel">{t("about.hero.badges.field.label")}</div>
                  <div className="badgeValue">{t("about.hero.badges.field.value")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container aboutContainer">
        {/* Vision Section */}
        <section className="visionSection">
          <div className="card pad visionCard">
            <div className="sectionIconWrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            </div>
            <h2 className="sectionTitle">{t("about.vision.title")}</h2>
            <p className="sectionContent">
              {t("about.vision.content")}
            </p>
          </div>
        </section>

        {/* Goals Section */}
        <section className="goalsSection">
          <h2 className="mainSectionTitle">{t("about.goals.title")}</h2>
          <div className="goalsGrid">
            <div className="goalCard">
              <div className="goalIconWrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <p>{t("about.goals.items.0")}</p>
            </div>
            <div className="goalCard">
              <div className="goalIconWrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
                </svg>
              </div>
              <p>{t("about.goals.items.1")}</p>
            </div>
            <div className="goalCard">
              <div className="goalIconWrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <p>{t("about.goals.items.2")}</p>
            </div>
            <div className="goalCard">
              <div className="goalIconWrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
                  <circle cx="8.5" cy="7" r="4"/>
                  <line x1="23" y1="11" x2="17" y2="11"/>
                  <line x1="20" y1="8" x2="20" y2="14"/>
                </svg>
              </div>
              <p>{t("about.goals.items.3")}</p>
            </div>
            <div className="goalCard">
              <div className="goalIconWrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <p>{t("about.goals.items.4")}</p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="valuesSection">
          <h2 className="mainSectionTitle">{t("about.values.title")}</h2>
          <div className="valuesContainer">
            <div className="valuesList">
              {values.map((value, index) => (
                <div
                  key={index}
                  className={`valueItem ${activeValue === index ? 'active' : ''}`}
                  onClick={() => setActiveValue(index)}
                  onMouseEnter={() => setActiveValue(index)}
                >
                  <span className="valueIcon">{getValueIcon(value.icon)}</span>
                  <span className="valueName">{value.name}</span>
                </div>
              ))}
            </div>
            <div className="valueDisplay">
              <div className="valueDisplayIcon">{getValueIcon(values[activeValue].icon)}</div>
              <h3 className="valueDisplayTitle">{values[activeValue].name}</h3>
              <p className="valueDisplayDesc">{values[activeValue].description}</p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="servicesSection">
          <div className="servicesHeader">
            <h2 className="mainSectionTitle">{t("about.services.title")}</h2>
            <p className="sectionSubtitle">{t("about.services.subtitle")}</p>
          </div>
          <div className="servicesGrid">
            {services.map((service, index) => (
              <div key={index} className="serviceCard">
                <div className="serviceIcon">{getServiceIcon(service.icon)}</div>
                <h3 className="serviceTitle">{service.title}</h3>
                <p className="serviceDescription">{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Vision 2030 Section */}
        <section className="vision2030Section">
          <div className="card pad vision2030Card">
            <div className="vision2030Header">
              <div className="vision2030IconWrapper">
                <img 
                  src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/1f1f8-1f1e6.svg" 
                  alt="Saudi Arabia Flag"
                  className="saudiFlag"
                />
              </div>
              <h2 className="sectionTitle">{t("about.vision2030.title")}</h2>
            </div>
            <p className="sectionContent">
              {t("about.vision2030.content")}
            </p>
            <div className="vision2030Features">
              <div className="feature">
                <span className="featureIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="12" y1="1" x2="12" y2="23"/>
                    <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/>
                  </svg>
                </span>
                <span>{t("about.vision2030.features.0")}</span>
              </div>
              <div className="feature">
                <span className="featureIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                  </svg>
                </span>
                <span>{t("about.vision2030.features.1")}</span>
              </div>
              <div className="feature">
                <span className="featureIconWrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
                <span>{t("about.vision2030.features.2")}</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}